import styled from 'styled-components';

export const TableHeader = styled.th`
  font-weight: bold;
`;
